import { EventBus } from "@/common/utils/event-bus";

export const state = {
    version: '1.0.0',
    pageModel: {},
    facets: {
        brands: [],
        categories: [],
        price: {
            maxPrice: 0,
            minPrice: 0
        }
    },
    query: {
        categoryId: 0,
        query: null,
        tags: null,
        sort: null,
        brands: null,
        minPrice: null,
        maxPrice: null
    },
    pagination: {
        currentPage: 1,
        totalRows: 0,
        perPage: 20
    }
}

export const mutations = {
    SET_PAGE_MODEL(state, model) {
        state.pageModel = model;
        state.pagination = model.pagination;
    },
    SET_FACETS(state, facets){
        state.facets = facets;
        state.pageModel.products.filterOption.brands.forEach(brand => {
            let facetBrand = facets.brands.find(x=>x.id === brand.id);
            if(facetBrand){
                brand.count = facetBrand.count;
            } else {
                brand.count = 0;
            }
        });
    },
    SET_PAGINATION_TOTAL(state, total){
        state.pagination.totalRows = total
    },
    SET_SORT_FILTER(state, sort){
        state.query.sort = sort
        state.pagination.currentPage = 1
        EventBus.$emit("product-filter");
    },
    SET_BRAND_FILTER(state, brands){
        state.query.brands = brands
    },
    SET_CATEGORY_FILTER(state, categoryId){
        state.query.categoryId = categoryId
    },
    SET_KEYWORD_FILTER(state, query){
        state.query.query = query
    },
    SET_PRICE_FILTER(state, {min = null, max = null}){
        state.query.minPrice = min
        state.query.maxPrice = max
        EventBus.$emit("product-filter");
    },
    SET_PAGE(state, page){
        state.pagination.currentPage = page
        EventBus.$emit("product-filter");
    },
    PAGINATION_INCREMENT(state){
        state.pagination.currentPage =  state.pagination.currentPage + 1;
    },
    SET_TAG_FILTER(state, tag){
        state.query.tags = tag
        state.pagination.currentPage = 1
        EventBus.$emit("product-filter");
    },
    RESET_FILTERS(state) {
        state.pagination.currentPage = 1;
        state.query.tags = null;
        state.query.sort = null;
        state.query.brands = null;
    }
}

export const getters = {
    filterQuery: state => {
        let query = {
            pageSize: state.pagination.perPage,
        }

        if(state.pageModel.query){
            query.query = state.pageModel.query
        }
        
        if(state.query.categoryId){
            query.categoryId = state.pageModel.category.id
        }
        
        if(state.pagination.currentPage > 1){
            query.page = state.pagination.currentPage;
        }
        
        if(state.query.tags){
            query.tags = state.query.tags.join(',');
        }
        
        if(state.query.sort){
            query.sort = state.query.sort;
        }

        if(state.query.brands){
            query.brands = state.query.brands;
        }

        if(state.query.brands){
            query.brands = state.query.brands;
        }

        if(state.query.minPrice){
            query.minPrice = state.query.minPrice;
        }

        if(state.query.maxPrice){
            query.maxPrice = state.query.maxPrice;
        }

        if(state.query.categoryId && state.query.categoryId > 0){
            query.categoryId = state.query.categoryId;
        }
        
        return query;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters
}
